import type { QueryKey } from '@tanstack/react-query';

import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import type { LabelsResponse } from '../../../../shared/labels';

function fetchOrganizationLabels() {
  return get<LabelsResponse>('/api/organizations/labels');
}

export const organizationLabelsQueryKey: QueryKey = ['organization', 'labels'];

/**
 * Hook to fetch the current organization's labels.
 *
 * Invalidate with `queryClient.invalidateQueries(organizationLabelsQueryKey)` after
 * mutations that create or delete labels.
 */
export const useOrganizationLabels = () => {
  return useQuery<LabelsResponse>({
    queryKey: organizationLabelsQueryKey,
    queryFn: fetchOrganizationLabels,
    staleTime: 60_000,
  });
};
